import { NgSwitch, NgSwitchCase, TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DeliveryStatus } from '../../models/deliveries/delivery-status';

@Component({
  selector: 'delivery-status',
  template: `
    <div [ngSwitch]="status">
      <ng-container *ngSwitchCase="availableStatuses.PENDING">
        <span
          class="inline-block border border-blue-700 rounded py-1 px-3 text-white bg-blue-500"
          >{{ status | titlecase }}</span
        >
      </ng-container>
      <ng-container *ngSwitchCase="availableStatuses.OVERDUE">
        <span
          class="inline-block border border-red-700 rounded py-1 px-3 text-white bg-red-500"
          >{{ status | titlecase }}</span
        >
      </ng-container>
      <ng-container *ngSwitchCase="availableStatuses.COMPLETE">
        <span
          class="inline-block border border-green-700 rounded py-1 px-3 text-white bg-green-500"
          >{{ status | titlecase }}</span
        >
      </ng-container>
    </div>
  `,
  providers: [],
  standalone: true,
  imports: [NgSwitch, NgSwitchCase, TitleCasePipe]
})
export class DeliveryStatusComponent {
  @Input() set delivery(value: { status: string; due: string }) {
    if (value.status === 'completed') {
      this.status = DeliveryStatus.COMPLETE;
      return;
    }
    if (new Date(value.due).getTime() < new Date().getTime()) {
      this.status = DeliveryStatus.OVERDUE;
      return;
    }
    this.status = DeliveryStatus.PENDING;
  }

  status: DeliveryStatus;
  availableStatuses = DeliveryStatus;
}
